<template lang="pug">
  div.marginTop
    app-divider(:label="titulo")
    div
      el-row(:gutter="30")
        el-col.boxInput(:span="4")
          validation-provider(rules="required|cep", v-slot="{ errors }", name="CEP")
            app-label(label="CEP:")
            el-input.input(
              name="CEP",
              v-model="endereco.cep",
              v-mask="['#####-###']",
              :class="{'erro' : errors.length}"
              :disabled="disabledFields"
              @change="buscarInfoByCep()"
              type="tel"
            )
            span.help.erro {{ errors[0] }}
        el-col.boxInput(:span="10")
          validation-provider(rules="required", v-slot="{ errors }", name="Logradouro")
            app-label(label="Logradouro:")
            el-input.input(
              name="logradouro",
              v-model="endereco.logradouro",
              maxlength="300",
              @blur="toUpperCase($event, 'ENDERECO')",
              :class="{'erro' : errors.length}"
              :disabled="disabledFields"
            )
            span.help.erro {{ errors[0] }}

        el-col.boxInput(:span="8")
          validation-provider(:rules="!endereco.semNumero ? 'required' : ''", v-slot="{ errors }", name="Número")
            app-label(label="Número:", :required="true")
            el-input.input(
              name='numero'
              v-model="endereco.numero",
              :onkeypress="onlyInputNumbers",
              maxlength="10"
              :showAppend ="true",
              :class="{'erro' : errors.length}"
              :disabled="disabledFields || endereco.semNumero"
            )
              el-checkbox.input(
                v-model="endereco.semNumero",
                label="S/N", slot="prepend",
                @change="onSemNumeroCheck"
                :disabled="disabledFields"
              )
            span.help.erro {{ errors[0] }}
      el-row(:gutter="30")
        el-col.boxInput(:span="12")
          app-label(label="Complemento:", :required='false')
          el-input.input(
            name="complemento",
            maxlength="100"
            v-model="endereco.complemento",
            @blur="toUpperCase($event, 'COMPLEMENTO')",
            :disabled="disabledFields"
          )
        el-col.boxInput(:span="12")
          validation-provider(rules="required", v-slot="{ errors }", name="Bairro")
            app-label(label="Bairro:")
            el-input.input(
              name="bairro",
              v-model="endereco.bairro",
              @blur="toUpperCase($event, 'BAIRRO')",
              maxlength="100"
              :class="{'erro' : errors.length}"
              :disabled="disabledFields"
            )
            span.help.erro {{ errors[0] }}

      el-row(:gutter="30")
        el-col.boxInput(:span="8")
          validation-provider(rules="required", v-slot="{ errors }", name="UF")
            app-label(label="UF:")
            el-select.input(
              width="100",
              class="select",
              v-model="codigoEstado",
              @change="changeEstado",
              no-match-text="Nenhuma UF encontrada",
              placeholder="Selecione",
              clearable,
              filterable,
              default-first-option=false,
              name="UF",
              :class="{'erro' : errors.length}"
              :disabled="disabledFields"
            )
              el-option(v-for="estado in estadosBr",
                :key="estado.codigo",
                :label="estado.nome",
                :value="estado.codigo"
              )
            span.help.erro {{ errors[0] }}

        el-col.boxInput(:span="12")
          validation-provider(rules="municipio_required", v-slot="{ errors }", name="Município")
            app-label(label="Município:", :required="true")
            el-select.input(
              v-model="municipio",
              @change="changeMunicipio"
              class="select",
              no-match-text="Nenhum município encontrado",
              placeholder="Selecione",
              filterable,
              value-key="id"
              default-first-option=false,
              :class="{'erro' : errors.length}"
              name="municipio",
              :disabled="disabledFields || !endereco.municipio.codigoEstado"
            )
              el-option(
                v-for="item in municipios",
                :key="item.id",
                :label="item.nome",
                :value="item"
              )
            span.help.erro {{ errors[0] }}
</template>

<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import estadosBr from '@/constants/estados'
import AppDivider from '@/components/AppDivider'

export default {
  mixins: [onlyInputNumbers, AppNotificacao],

  components: {
    AppLabel,
    AppDivider
  },

  props: {
    endereco: {
      required: true
    },
    nomeAba: {
      type: String,
      required: false
    },
    titulo: {
      type: String,
      required: false,
      default: 'Endereço'
    },
    disabledFields: {
      type: Boolean,
      default: false
    },
    upperCaseApply: {
      type: Boolean,
      default: false
    },
    codigoEstado: {
      default: null
    },
    municipio: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      estadosBr,
      municipios: []
    }
  },

  methods: {
    ...mapActions({
      getMunicipiosByUf: 'municipios/findMunicipiosByUf',
      enderecoByCep: 'endereco/findEnderecoByCep'
    }),

    changeEstado (value) {
      if (!value.codigoEstado) this.municipio = null
      this.endereco.municipio = { codigoEstado: value, id: null }
    },

    changeMunicipio (value) {
      this.endereco.municipio = { codigoEstado: this.codigoEstado, id: value.id }
    },

    changeEstadoMunicipio (value) {
      if (!value || !value.codigoEstado) {
        this.municipio = null
      } else {
        this.endereco.municipio = {
          codigoEstado: value.codigoEstado,
          id: value.idMunicipio ? Number(value.idMunicipio) : null
        }
      }
    },

    onSemNumeroCheck (checked) {
      if (checked) {
        this.endereco.numero = 0
        return
      }

      this.endereco.numero = null
    },

    toUpperCase (event, label) {
      if (this.upperCaseApply) {
        if (label === 'ENDERECO') {
          this.endereco.logradouro = this.endereco.logradouro.toUpperCase()
        } else if (label === 'COMPLEMENTO') {
          this.endereco.complemento = this.endereco.complemento.toUpperCase()
        } else if (label === 'BAIRRO') {
          this.endereco.bairro = this.endereco.bairro.toUpperCase()
        }
      }
    },

    async buscarInfoByCep () {
      try {
        const data = await this.enderecoByCep(this.endereco.cep)
        if (data.erro) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'CEP não encontrado!'
          )
          return
        }
        this.preencherCampos(data)
      } catch (error) {
        console.error('Erro ao buscar o CEP:', error)
      }
    },

    preencherCampos (data) {
      this.endereco.logradouro = data.logradouro.toUpperCase()
      this.endereco.bairro = data.bairro.toUpperCase()
      this.endereco.complemento = data.complemento.toUpperCase()
      this.endereco.uf = data.uf
      this.changeEstadoMunicipio({codigoEstado: data.uf, idMunicipio: data.ibge})
    }
  },

  watch: {
    'codigoEstado': {
      async handler (oldval, newval) {
        if (oldval !== newval && this.endereco.municipio.codigoEstado) {
          this.endereco.uf = this.endereco.municipio.codigoEstado
          this.municipios = await this.getMunicipiosByUf(this.endereco.municipio.codigoEstado)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .el-row {
    margin-bottom: 20px;
  }

  @media (max-width: 750px) {
    .el-row {
      display: flex;
      flex-direction: column;
    }

    .boxInput {
      width: 100%;
    }
  }
  .select {
    width: 100%;
  }
  .tittle {
    border: 1px solid #dfe4ed;
    margin-bottom: 15px;
    font-weight: 700;
  }
  .labelDivider {
    color: #606266 !important;
    font-size: 1em;
    margin-top: 25px;
    margin-bottom: 5px;
    font-weight: 600;
  }
  .marginTop {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppEndereco.vue